module.exports = __webpack_public_path__ + "img/card-profile1.a0949f48.jpg";